/// <amd-dependency path='VSS/LoaderPlugins/Css!TestManagement' />

import * as React from "react";
import { registerLWPComponent } from "VSS/LWP";
import WIT_Integration = require("Build/Scripts/WorkItemIntegration.Linking");
import VSS_Dialogs = require("VSS/Controls/Dialogs");
import TFS_Host_TfsContext = require("Presentation/Scripts/TFS/TFS.Host.TfsContext");
import BuildContracts = require("TFS/Build/Contracts");

export interface FindBuildsDialogProxyProps {
    okCallback(build: BuildContracts.Build): void;
}

// This is a proxy component to open find builds dialog from run with options dialog using LegacyComponent.
class FindBuildsDialogProxy extends React.Component<FindBuildsDialogProxyProps, {}> {
    public render(): React.ReactNode {
        return <div />;
    }

    public componentDidMount(): void {
        let tfsContext = TFS_Host_TfsContext.TfsContext.getDefault();
        let model = new WIT_Integration.BuildPickerDialogModel(
            tfsContext,
            (build: BuildContracts.Build) => {
                this.props.okCallback(build);
            },
            "test-plans-hub-refresh-find-builds-dialog v-scroll-auto custom-scrollbar",
            false
        );
        VSS_Dialogs.show(WIT_Integration.BuildPickerDialog, model);
    }
}

registerLWPComponent("find-builds-dialog-proxy", FindBuildsDialogProxy);
